import React from 'react';
import { EdgeProps, getBezierPath } from '@xyflow/react';

export const AnimatedEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
        strokeWidth={2}
        stroke={selected ? '#3b82f6' : '#9ca3af'}
        fill="none"
      />
      <path
        d={edgePath}
        strokeWidth={3}
        stroke={selected ? '#60a5fa' : '#d1d5db'}
        fill="none"
        strokeDasharray="8 12"
        className="animate-dash"
      />
    </>
  );
};